<template lang="pug">
  .display-flex.height-100
    .margin-auto
      .half-width.margin-auto.margin-top-10
        h3.title Boletines Mensuales
        p
        p.subtitle Esta opcion se encuentra en desarrollo
</template>

<script>
export default {
  name: 'boletines',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">

</style>



// WEBPACK FOOTER //
// Boletines_Mensuales_View.vue?73a171aa